<div class="mtlr-3" style="display:flex;flex-direction: column;">
    <div>
        <app-bulk-update-toolbox #bulk_update_action (buttonAction)="onButtonAction($event)"></app-bulk-update-toolbox>
    </div>
    <div style="width: 100%;height: calc(100vh - 245px);margin-top: 10px;">
        <app-formly-bulk-update-view></app-formly-bulk-update-view>
    </div>
</div>
